export default __webpack_public_path__ + "static/Syklist-578b8a3aa58cc7cad3b3be53dd616398.png";